import type { FluxPesEnAttente } from '../../services/pes/importPes';
import { dateCourte, normaliser } from './format';

/** Colonne triable de la liste des flux en attente, et sens (classes du tri de ListeTable). */
export type TriFluxEnAttente = Partial<
	Record<keyof FluxPesEnAttente, 'ascending' | 'descending'>
>;

/** Flux en attente par sa source, son type et sa date, dans la page comme dans le compte rendu. */
export const libelleFlux = (flux: FluxPesEnAttente) =>
	`Fichier en attente : ${[flux.codeSrc, flux.nom, dateCourte(flux.dateCreation)].filter(Boolean).join(', ')}`;

/** Flux dont la source, le nom ou la date contient le terme (casse et accents ignorés). */
export const filtrerFlux = (flux: FluxPesEnAttente[], recherche: string) => {
	const terme = normaliser(recherche.trim());
	if (terme === '') {
		return flux;
	}
	return flux.filter((element) =>
		normaliser(
			[
				element.codeSrc ?? '',
				element.nom ?? '',
				dateCourte(element.dateCreation),
			].join(' '),
		).includes(terme),
	);
};

/**
 * Tri sur plusieurs colonnes, dans l'ordre où l'utilisateur les a choisies ; sans tri, l'ordre de l'API (du plus
 * récent au plus ancien) est gardé.
 */
export const trierFlux = (flux: FluxPesEnAttente[], tri: TriFluxEnAttente) => {
	const colonnes = Object.entries(tri) as [
		keyof FluxPesEnAttente,
		'ascending' | 'descending',
	][];
	if (colonnes.length === 0) {
		return flux;
	}
	return [...flux].sort((a, b) => {
		for (const [colonne, sens] of colonnes) {
			const [x, y] = [a[colonne] ?? '', b[colonne] ?? ''];
			const ecart =
				typeof x === 'number' && typeof y === 'number'
					? x - y
					: String(x).localeCompare(String(y), 'fr', { numeric: true });
			if (ecart !== 0) {
				return sens === 'ascending' ? ecart : -ecart;
			}
		}
		return 0;
	});
};
